import { render, staticRenderFns } from "./CourseMentor.vue?vue&type=template&id=99ccb5c8&scoped=true&"
import script from "./CourseMentor.vue?vue&type=script&lang=js&"
export * from "./CourseMentor.vue?vue&type=script&lang=js&"
import style0 from "./CourseMentor.vue?vue&type=style&index=0&id=99ccb5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ccb5c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
